import React, { useEffect, useState } from 'react'
import { format, isEqual } from 'date-fns'
import { Typography } from '@telavita-core/react-design-kit'

import { Reservation } from 'models/Reservation'
import { ReactComponent as AlertIcon } from 'static/svg/alert-icon.svg'

import LineSeparator from 'components/LineSeparator'
import { SelectAvailableProfessionalSchedule } from 'components'

import * as S from './styles'

interface SelectNewReservationDateProps {
  date: { [key: string]: string[] }
  reservation: Reservation
  handleSelectDate: ({ oldDate, newDate }) => void
}

function formatDate(date: Date) {
  const day = format(date, 'dd/MM')
  const time = format(date, 'HH:mm')

  return `${day} às ${time}`
}

export const SelectNewReservationDate: React.FC<SelectNewReservationDateProps> = ({
  date,
  reservation,
  handleSelectDate,
}) => {
  const [newSelectedReservationDate, setNewSelectedReservationDate] = useState<Date | null>(null)
  const currentReservationDate = new Date(Object.keys(date)[0])
  
  function handleSelectNewReservationDate(date: string) {
    const newDate = date ? new Date(date) : null

    setNewSelectedReservationDate(newDate)
    handleSelectDate({
      oldDate: currentReservationDate,
      newDate
    })
  }

  useEffect(() => {
    if (newSelectedReservationDate) {
      if (isEqual(newSelectedReservationDate, currentReservationDate)) {
        setNewSelectedReservationDate(null)
      }
    }
  }, [newSelectedReservationDate, currentReservationDate])

  return (
    <S.DateSelectWrapper>
      <S.SelectWrapper>
        <SelectAvailableProfessionalSchedule
          availabilityList={date}
          patientUsername={reservation.patientUsername}
          professionalUsername={reservation.professionalUsername}
          handleDate={(date) => handleSelectNewReservationDate(date)}
          defaultSelectedTime={{
            id: String(currentReservationDate),
            label: format(currentReservationDate, 'HH:mm'),
          }}
        />
      </S.SelectWrapper>

      {newSelectedReservationDate && (
        <S.AlertInfoWrapper>
          <AlertIcon />
          <Typography variant='content3'>
            Remarcando de <strong className='alertInfoText'>{formatDate(currentReservationDate)}</strong>{' '}
            para <strong>{formatDate(new Date(newSelectedReservationDate))}</strong>
          </Typography>
        </S.AlertInfoWrapper>
      )}

      <LineSeparator 
        lineColor='#E2E2E2'
        lineHeight='1px'
        lineMargin='20px 0'
        lineWidth='100%'
      />
    </S.DateSelectWrapper>
  )
}